"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountTaxStatusToJSON = exports.AdAccountTaxStatusFromJSONTyped = exports.AdAccountTaxStatusFromJSON = exports.AdAccountTaxStatus = void 0;
/**
 * The validation status of the tax ID.
 * @export
 */
exports.AdAccountTaxStatus = {
    Valid: 'VALID',
    Processing: 'PROCESSING',
    Invalid: 'INVALID',
    Unknown: 'UNKNOWN',
    UnexpectedError: 'UNEXPECTED_ERROR',
    RetryableError: 'RETRYABLE_ERROR',
    NonRetryableError: 'NON_RETRYABLE_ERROR'
};
function AdAccountTaxStatusFromJSON(json) {
    return AdAccountTaxStatusFromJSONTyped(json, false);
}
exports.AdAccountTaxStatusFromJSON = AdAccountTaxStatusFromJSON;
function AdAccountTaxStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdAccountTaxStatusFromJSONTyped = AdAccountTaxStatusFromJSONTyped;
function AdAccountTaxStatusToJSON(value) {
    return value;
}
exports.AdAccountTaxStatusToJSON = AdAccountTaxStatusToJSON;
